<script setup lang="ts">
import loginVisual from '../assets/login_visual.svg';
import headerLogo from '../assets/header_logo.svg';
</script>

<template>
  <div class="@container h-full">
    <div class="flex flex-col @[1280px]:flex-row h-full">
      <div
        class="login-banner-wrapper relative flex flex-[1_1_20%] @[768px]:flex-[1_1_40%] @[1024px]:flex-[1_1_50%] flex-col min-h-16"
      >
        <img
          class="absolute opacity-50 @[1280px]:opacity-100 left-1/2 -translate-x-1/2 @[1280px]:left-auto
            @[1280px]:translate-x-0 @[1280px]:right-0 @[1280px]:top-1/2 @[1280px]:-translate-y-1/2 @[1024px]:mt-20 @[1280px]:mt-0
            w-152.5 @[1280px]:w-218.5"
          alt=""
          :src="loginVisual"
        >
        <img
          class="z-10 w-75 @[768px]:w-87.5 m-auto @[1280px]:mt-8 @[1280px]:ml-8"
          alt="intellivend Logo"
          :src="headerLogo"
        >
      </div>

      <div class="flex flex-[1_1_80%] @[768px]:flex-[1_1_60%] @[1024px]:flex-[1_1_50%] flex-col @[1024px]:justify-center items-center @[1280px]:items-start bg-slate-50">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.login-banner-wrapper {
  background: var(--p-secondary-900) url('../assets/login_background.svg') no-repeat;
  background-size: 100% auto;
  overflow: hidden;
}

/* Style amplify components like our primevue components */
[data-amplify-authenticator] {
  --amplify-components-authenticator-router-border-width: 0;
  --amplify-components-authenticator-form-padding:
    var(--amplify-space-medium) var(--amplify-space-xl) var(--amplify-space-xl);
  --amplify-components-button-primary-background-color: var(--p-primary-500);
  --amplify-components-button-primary-hover-background-color: var(--p-primary-500);
  --amplify-components-button-link-color: var(--p-primary-500);
  --amplify-components-button-link-hover-background-color: var(--p-primary-100);
  --amplify-components-flex-gap: 1.5rem;
  --amplify-components-icon-height: 1.5rem;
  --amplify-components-authenticator-router-box-shadow: none;
  --amplify-components-button-focus-box-shadow: none;
  --amplify-components-authenticator-router-background-color: transparent;
  --amplify-components-authenticator-container-width-max: 100%;
  --amplify-components-authenticator-form-padding: 0;
  --amplify-components-fieldcontrol-background-color: #fff;
  --amplify-components-fieldcontrol-focus-box-shadow: none;
  width: 100%;
}

[data-amplify-authenticator] [data-amplify-container] {
  width: 100%;
  max-width: 100%;
}

[data-amplify-router] {
  box-shadow: none;
  width: 100%;
  max-width: 100%;
}

[data-amplify-router-content] {
  width: 100%;
  max-width: 100%;
}

.amplify-input,
.amplify-field__show-password {
  border: 0.1rem solid #d1d5db;
  border-radius: 0.4rem !important;
}

.amplify-field__show-password {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.amplify-field-group :not(:last-child) .amplify-input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.amplify-input:focus,
.amplify-button:focus {
  border-color: #85898F;
  box-shadow: none;
}

.amplify-field-group__field-wrapper,
.amplify-field-group__outer-end .amplify-field-group__control {
  background-color: #fff;
}

.amplify-alert .amplify-authenticator__icon-wrapper {
  align-items: var(--amplify-components-alert-align-items);
}
</style>
